












import { Component, Vue } from "vue-property-decorator";
import LoginWidget from "@/components/LoginWidget.vue";

@Component({ components: { LoginWidget } })
export default class MainView extends Vue {}
